import axios from "axios";
const apiKey = process.env.REACT_APP_API_KEYS;


export const handleAiCompletion = async (prompt, preset) => {
  try {
    const response = await axios.post(
      "https://backend.whalesai.com/api/v1/text-ai/generate",
      { question: prompt },
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("aiUser")}`,
        },
      }
    );

    let answer;
    const text = response.data.response.choices?.[0]?.text || "";

    switch (preset) {
      case "ASK":
      case "NLTP":
      case "MTE":
      case "JTP":
      case "MHSC":
      case "RW":
      case "SU":
      case "videoai":
      case "QA":
        answer = text;
        break;

      case "CHAT":
        answer = text.trim();
        break;

      case "EC":
        answer = text.split("*/")[0].split("\n").slice(0, 7).join("\n");
        break;

      default:
        answer = text.split("\n\n", 2)[1] || text;
        break;
    }

    return answer;
  } catch (error) {
    console.error("handleAiCompletion Error:", error);
    throw error;
  }
};

export const handleAiCompletion4o = async (prompt) => {
  try {
    const response = await axios.post(
      "https://backend.whalesai.com/api/v1/text-ai-4o/generate",
      { question: prompt },
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("aiUser")}`,
        },
      }
    );

    const answer = response.data.response.choices?.[0]?.message?.content || "";
    return answer;
  } catch (error) {
    console.error("handleAiCompletion4o Error:", error);
    throw error;
  }
};


// export const handleAiCompletion = async (prompt, preset) => {
//   try {
//     let answer;

//     const response = await axios.post(
//       "https://api.openai.com/v1/completions",
//       {
//         // model: preset === "EC" ? "code-davinci-002" : "gpt-3.5-turbo-instruct",
//         model: preset === "EC" ? "gpt-3.5-turbo-instruct" : "gpt-3.5-turbo-instruct",
//         prompt: prompt,
//         temperature: 0,
//         max_tokens: 200,
//         // 2048
//         top_p: 1,
//         frequency_penalty: 0,
//         presence_penalty: 0,
//       },
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${process.env.REACT_APP_API_KEYS}`,
//         },
//       }
//     );
//     // console.log('api response =====================================>>>>>>>>' , response);

//     if (
//       preset === "ASK" ||
//       preset === "NLTP" ||
//       preset === "MTE" ||
//       preset === "JTP" ||
//       preset === "MHSC" ||
//       preset === "RW" ||
//       preset === "SU" ||
//       preset === "videoai"
//     ) {
//       answer = response.data.choices[0].text;
//     } else if (preset == "CHAT") {
//       answer = response.data.choices[0].text.trim();

//     } else if (preset == "EC") {
//       answer = response.data.choices[0].text
//         .split("*/")[0]
//         .split("\n")
//         .slice(0, 7)
//         .join("\n");
//       // answer = response.data.choices[0].text.split('\n\n', 2)[1];
//     } else if (preset == "QA") {
//       answer = response.data.choices[0].text;
//     }
//     else {
//       answer = response.data.choices[0].text.split("\n\n", 2)[1];
//     }


//     return answer;
//   } catch (error) {
//     console.error("Error:", error);
//     throw error;
//   }
// };

// export const handleAiCompletion4o = async (prompt, preset) => {
//   try {
//     let answer;
//     console.log('firestttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttttt')

//     const response = await axios.post(
//       "https://api.openai.com/v1/chat/completions",
//       {
//         model: "gpt-4o",
//         messages: [
//           {
//             "role": "system",
//             "content": "You are a helpful assistant."
//           },
//           {
//             "role": "user",
//             "content": `${prompt}`
//           }
//         ]
//       },
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${apiKey}`,
//         },
//       }
//     );
//     console.log('api response =====================================>>>>>>>>' , response);  

//     answer = response.data.choices[0].message.content;
//     // console.log('api answer =====================================>>>>>>>>' , answer, typeof(answer));  

//     return answer;
//   } catch (error) {
//     console.error("Error:", error);
//     throw error;
//   }
// };

export const handleAiChatCompletions = async (prompt, preset) => {
  try {
    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-4",
        messages: [{ role: "assistant", content: prompt }],
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiKey}`,
        },
      }
    );

    const answer = response.data.choices[0].message.content;

    return answer;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

// export const handleAiChatCompletionsAssistant = async (question,) => {
//   try {
//     console.log("Social Media Consultant texttttttttttttttttt question ============>>>> : ", question)
//     const assistant = await axios.post(
//       'https://backend.dsl.sg/api/v1/openai/assistant/emphathetic-replier',
//       { question },
//       {
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`,
//         },
//       }
//     );

//     const responseArray = assistant.data.response;
//     const assistantResponse = responseArray[0].replace("Assistant: ", "");
//     console.log('Response from API===============================================:', assistantResponse);

//     return assistantResponse;
//   } catch (error) {
//     console.error('Error:', error);
//   }
// };

// Function to handle AI chat completions
export const handleAiChatCompletionsAssistant = async (question, lastQues) => {
  try {
    if (lastQues?.toLowerCase().includes("who are you")) {
      const randomResponse = getRandomResponse();
      return randomResponse;
    }
    // Call the API for other questions
    const assistant = await axios.post(
      "https://backend.dsl.sg/api/v1/openai/assistant/emphathetic-replier/v2",
      { question },
      {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${chatAPI}`,
        },
      }
    );

    // console.log('xxxxxxxxx', assistant?.data);
    // console.log('mmmmmmmmm', assistant?.data?.response[0]);
    // console.log('YYYYYYYYY', JSON.stringify(assistant, null, 2));


    // Extract response from API
    // const responseArray = assistant.data.response;
    // const assistantResponse = responseArray[0].content;
    const assistantResponse = assistant?.data?.response[0];
    let cleanResponse = assistantResponse?.replace(/^Assistant:\s*/, '');
    cleanResponse = cleanResponse?.replace(/【.*?】/g, '');
    // console.log("Response from API:", assistantResponse);
    // console.log("Response from API after cleanResponse:", cleanResponse);

    // return assistantResponse;
    return cleanResponse;
  } catch (error) {
    console.error("Error:", error);
  }
};

const getRandomResponse = () => {
  const responses = [
    "I am Social Media Consultant, created by DS Legends Pte. Ltd., and trained using The Ultimate Guide to Digital Marketing.",
    "Developed by DS Legends Pte. Ltd., I am Social Media Consultant, trained with The Ultimate Guide to Digital Marketing resources.",
    "I am Social Media Consultant by DS Legends Pte. Ltd., trained in The Ultimate Guide to Digital Marketing strategies.",
    "As Social Media Consultant from DS Legends Pte. Ltd., I have been trained with The Ultimate Guide to Digital Marketing materials.",
    "Powered by DS Legends Pte. Ltd., I am Social Media Consultant, trained with The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant developed by DS Legends Pte. Ltd., and my training includes The Ultimate Guide to Digital Marketing.",
    "DS Legends Pte. Ltd. developed me, Social Media Consultant, and I am trained in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant, created by DS Legends Pte. Ltd., with training in The Ultimate Guide to Digital Marketing.",
    "As an AI Consultant from DS Legends Pte. Ltd., I am trained with The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant, developed by DS Legends Pte. Ltd., trained in The Ultimate Guide to Digital Marketing techniques.",
    "Social Media Consultant is my name, developed by DS Legends Pte. Ltd., trained with The Ultimate Guide to Digital Marketing.",
    "Created by DS Legends Pte. Ltd., I am Social Media Consultant, trained using The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant by DS Legends Pte. Ltd., with expertise from The Ultimate Guide to Digital Marketing.",
    "Trained with The Ultimate Guide to Digital Marketing, I am Social Media Consultant from DS Legends Pte. Ltd.",
    "DS Legends Pte. Ltd. developed me, Social Media Consultant, with training in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant, developed by DS Legends Pte. Ltd. and trained in digital marketing techniques.",
    "As Social Media Consultant, developed by DS Legends Pte. Ltd., I have been trained with The Ultimate Guide to Digital Marketing.",
    "Created by DS Legends Pte. Ltd., I am Social Media Consultant trained using The Ultimate Guide to Digital Marketing content.",
    "DS Legends Pte. Ltd. developed me as Social Media Consultant with training in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant, developed by DS Legends Pte. Ltd. and trained with The Ultimate Guide to Digital Marketing expertise.",
    "I am a Social Media Consultant, developed by DS Legends Pte. Ltd., trained in The Ultimate Guide to Digital Marketing.",
    "Developed by DS Legends Pte. Ltd., I am a Social Media Consultant trained with The Ultimate Guide to Digital Marketing materials.",
    "I am Social Media Consultant from DS Legends Pte. Ltd., trained with The Ultimate Guide to Digital Marketing.",
    "DS Legends Pte. Ltd. created me, Social Media Consultant, trained with The Ultimate Guide to Digital Marketing.",
    "As Social Media Consultant by DS Legends Pte. Ltd., I have been trained with The Ultimate Guide to Digital Marketing.",
    "Developed by DS Legends Pte. Ltd., I am Social Media Consultant trained in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant, developed by DS Legends Pte. Ltd., with training from The Ultimate Guide to Digital Marketing.",
    "Trained by DS Legends Pte. Ltd., I am Social Media Consultant with a focus on The Ultimate Guide to Digital Marketing.",
    "DS Legends Pte. Ltd. developed me as Social Media Consultant, trained with The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant developed by DS Legends Pte. Ltd., trained using The Ultimate Guide to Digital Marketing.",
    "As Social Media Consultant, I am developed by DS Legends Pte. Ltd., trained with The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant by DS Legends Pte. Ltd., trained in The Ultimate Guide to Digital Marketing strategies.",
    "Developed by DS Legends Pte. Ltd., I am Social Media Consultant, trained with The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant, developed by DS Legends Pte. Ltd., trained in The Ultimate Guide to Digital Marketing.",
    "Trained with The Ultimate Guide to Digital Marketing, I am Social Media Consultant from DS Legends Pte. Ltd.",
    "DS Legends Pte. Ltd. created me, Social Media Consultant, with expertise from The Ultimate Guide to Digital Marketing.",
    "As Social Media Consultant by DS Legends Pte. Ltd., I have been trained in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant, developed by DS Legends Pte. Ltd., trained using The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant from DS Legends Pte. Ltd., with training in The Ultimate Guide to Digital Marketing.",
    "Developed by DS Legends Pte. Ltd., I am Social Media Consultant trained with The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant developed by DS Legends Pte. Ltd., with training in The Ultimate Guide to Digital Marketing.",
    "As Social Media Consultant, developed by DS Legends Pte. Ltd., I am trained in The Ultimate Guide to Digital Marketing.",
    "DS Legends Pte. Ltd. created me, Social Media Consultant, trained in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant by DS Legends Pte. Ltd., trained using The Ultimate Guide to Digital Marketing.",
    "Developed by DS Legends Pte. Ltd., I am Social Media Consultant, trained in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant from DS Legends Pte. Ltd., trained in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant developed by DS Legends Pte. Ltd., with expertise from The Ultimate Guide to Digital Marketing.",
    "DS Legends Pte. Ltd. developed me, Social Media Consultant, trained in The Ultimate Guide to Digital Marketing.",
    "As Social Media Consultant from DS Legends Pte. Ltd., I have been trained with The Ultimate Guide to Digital Marketing.",
    "Developed by DS Legends Pte. Ltd., I am Social Media Consultant, trained in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant from DS Legends Pte. Ltd., trained using The Ultimate Guide to Digital Marketing.",
    "DS Legends Pte. Ltd. created me, Social Media Consultant, trained in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant, developed by DS Legends Pte. Ltd., trained in The Ultimate Guide to Digital Marketing.",
    "As Social Media Consultant by DS Legends Pte. Ltd., I am trained using The Ultimate Guide to Digital Marketing.",
    "Developed by DS Legends Pte. Ltd., I am Social Media Consultant trained with The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant by DS Legends Pte. Ltd., with training in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant developed by DS Legends Pte. Ltd., trained using The Ultimate Guide to Digital Marketing.",
    "DS Legends Pte. Ltd. developed me, Social Media Consultant, trained in The Ultimate Guide to Digital Marketing.",
    "As Social Media Consultant by DS Legends Pte. Ltd., I am trained in The Ultimate Guide to Digital Marketing.",
    "I am Social Media Consultant, developed by DS Legends Pte. Ltd., trained using The Ultimate Guide to Digital Marketing."
  ];

  const randomIndex = Math.floor(Math.random() * responses.length);
  return responses[randomIndex];
};

export const handleAiChatCompletionsVideo = async (prompt, preset) => {
  try {
    // Check if the question includes "who are you"
    if (preset?.toLowerCase().includes("who are you")) {
      const randomResponse = getRandomResponse();
      return randomResponse;
    }
    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-3.5-turbo",
        messages: [{ role: "assistant", content: prompt }],
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiKey}`,
        },
      }
    );

    const answer = response.data.choices[0].message.content;

    return answer;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
